const ItemContainer = ({ label, content, isHTML }) => {
  return (
    <div className="w-full flex-1">
      {isHTML ? (
        <div className=" flex flex-col items-start justify-start p-2 text-text-1 mt-2">
          <h5 className="px-1 font-medium text-nowrap">{label}</h5>
          <div className="text-text-1/75">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      ) : (
        <div className="px-2 text-text-1 mt-2  ">
          <div className="flex items-start justify-start gap-2 ">
            <h5 className=" font-medium text-nowrap">{label}</h5>
            <p className="text-text-1/75">{content}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemContainer;
